import React from "react";

const Divider = ({ icon, title, style }) => {
  return (
    <div className="row" style={style}>
      <div className="d-flex align-items-center justify-content-center pt-2 pb-2">
        <div
          className="col-lg-1 m-0 p-0"
          style={{ height: "1px", backgroundColor: "#d3d3d3" }}
        />
        <div
          className="col-lg-3 d-flex p-0 justify-content-center text-primary"
          style={{
            whiteSpace: "nowrap",
            alignItems: "center",
            width: "12rem",
          }}
        >
          <i className={icon} /> <span>{title}</span>
        </div>
        <div
          className="col-lg-8"
          style={{ height: "1px", backgroundColor: "#d3d3d3" }}
        />
      </div>
    </div>
  );
};

export default Divider;
